module.exports = __webpack_public_path__ + "img/gb9121_3_r.prt.440ea45d.jpg";